<router-outlet></router-outlet>
<ng-container *ngIf="route.children.length === 0">
  <div class="page-container">
    <div class="card">
      <ng-container *ngIf="!state.loading; else stateLoading;">
        <ng-container *ngIf="!state.error; else stateError;">
          <div class="content">
            <div class="header-container">
              <h4 class="m-top-0 m-bottom-0">Training videos</h4>
            </div>
      
            <ng-container *ngIf="videoListMaster.length > 0; else noVideosExisting">
              <div class="filter-container">
                <app-universal-filter
                  [newUI]="true"
                  [searchControl]="universalFilterData.searchControl" [filterOptions]="universalFilterData.filterOptions"
                  [searchProps]="universalFilterData.searchProps" [defaultFilters]="universalFilterData.defaultFilters"
                  (resultEmit)="filterEmit($event)" (categoriesChanged)="filterCategoriesChanged($event)"></app-universal-filter>
              </div>
            
              <div class="video-list-container">
                <ng-container *ngIf="videoListFiltered.length > 0; else noVideosFiltered">
                  <div class="video-grid">
                    <ng-container *ngFor="let video of videoListDisplay">
                      <div class="video-item-wrapper" [routerLink]="[video.id]">
                        <app-video-library-video-card [videoData]="video"></app-video-library-video-card>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
          
                <ng-template #noVideosFiltered>
                  <div class="p-top-15 p-bottom-15 text-center">
                    <img class="icon-padding new-icon-height" src="/assets/img/NoSearchFound.svg" />
                    <br/>
                    <span>No videos were found matching this your filters.</span>
                  </div>
                </ng-template>
          
                <app-pagination-new-component [arrayData]="videoListFiltered" [arrayDisplay]="videoListDisplay"></app-pagination-new-component>
              </div>
            </ng-container>
      
            <ng-template #noVideosExisting>
              <div class="p-top-15 p-bottom-15 text-center">
                <img class="icon-padding new-icon-height" src="/assets/img/NoSearchFound.svg" />
                <br/>
                <span>No videos were found.</span>
                <br/>
                <br/>
                <button class="btn-frankli-round btn-frankli-green" (click)="getData()">Try again</button>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #stateLoading>
        <app-loading-state [showMessage]="false"></app-loading-state>
      </ng-template>
    
      <ng-template #stateError>
        <div class="p-top-15 p-bottom-15 text-center">
          <img class="icon-padding new-icon-height" src="/assets/img/Error.svg" />
          <br/>
          <span>An error occurred while loading our videos</span>
          <br/>
          <span>{{state.errorMessage}}</span>
          <br/>
          <span class="btn-frankli-round btn-frankli-green m-top-10" [routerLink]="'/dashboard'">
            Back to your dashboard?
          </span>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>